var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("span", [
    _vm.isCorrect === null
      ? _c(
          "span",
          {
            staticClass: "has-text-warning-dark is-inline-block",
            class: { "has-text-weight-semibold": _vm.isBold },
          },
          [_vm._v(_vm._s(_vm.$t("term.ungraded")))]
        )
      : _vm.isCorrect === true
      ? _c(
          "span",
          {
            staticClass: "has-text-success is-inline-block",
            class: { "has-text-weight-semibold": _vm.isBold },
          },
          [_vm._v(_vm._s(_vm.$t("term.correct")))]
        )
      : _vm.isCorrect === false
      ? _c(
          "span",
          {
            staticClass: "has-text-danger is-inline-block",
            class: { "has-text-weight-semibold": _vm.isBold },
          },
          [_vm._v(_vm._s(_vm.$t("term.incorrect")))]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }